import React from 'react';
import gql from 'graphql-tag';
import Layout from '../../components/Layout';
import CompletePayment from './CompletePayment';

const QUERY = gql`
  query ($token: String) {
    getPendingBookingByToken(token: $token) {
      status state bookingId amount currency serviceName firstName location
      publishableKey hasCard cardBrand cardLast4
    }
  }
`;

// PUBLIC route /complete-payment/:token — the client reviews and authorizes their Manual Job booking.
async function action({ params, client }) {
  let data = null;
  try {
    const res = await client.query({ query: QUERY, variables: { token: params.token }, fetchPolicy: 'network-only' });
    data = res && res.data && res.data.getPendingBookingByToken;
  } catch (e) { data = null; }

  return {
    title: 'Confirm your booking — BestHand',
    description: 'Review and confirm your BestHand booking.',
    component: (
      <Layout>
        <CompletePayment data={data} token={params.token} />
      </Layout>
    ),
  };
}

export default action;
